import { render } from "./UserBarComponent.vue?vue&type=template&id=eeb78a44"
import script from "./UserBarComponent.vue?vue&type=script&lang=js"
export * from "./UserBarComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__